import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBatteryEmpty"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5H20V8H23V16H20V19H1V5ZM20 14H21V10H20V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryEmpty;
